import React from 'react';
import './AutomotiveIntro.css';
import automotiveImg from '../../assets/images/automotive.jpeg'; // Import image

const AutomotiveIntro = () => {
  return (
    <section className="automotive-intro-section">
      <div className="container">
        <div className="automotive-intro-grid">
          <div className="automotive-image-container">
            <img 
              src={automotiveImg} // Use imported image
              alt="Automotive Industry" 
              className="automotive-image"
            />
          </div>
          <div className="automotive-text-content">
            <h2 className="automotive-title">Why Choose NeuroverseAI?</h2>
            <p>
              <strong>SAP Process Automation</strong> refers to a set of tools and technologies within the SAP ecosystem designed to automate business processes, improve operational efficiency, and reduce manual effort. It combines elements of <strong>workflow management</strong>, <strong>robotic process automation (RPA)</strong>, and <strong>business rules management</strong> to streamline and optimize repetitive or complex tasks across various departments.
            </p>
            <h3 className="use-cases-title">Use Cases for SAP Process Automation</h3>
            <div className="use-cases-grid">
              <div className="use-case-card">
                <h4>Finance</h4>
                <p>Automating invoice validation and processing. Generating financial reports and audits.</p>
              </div>
              <div className="use-case-card">
                <h4>Human Resources</h4>
                <p>Onboarding processes for new hires. Managing employee requests (e.g., leave approvals, payroll adjustments).</p>
              </div>
              <div className="use-case-card">
                <h4>Supply Chain</h4>
                <p>Automating order confirmations and inventory updates. Optimizing logistics and delivery tracking.</p>
              </div>
              <div className="use-case-card">
                <h4>Customer Service</h4>
                <p>Automating ticket assignment and resolution workflows. Personalizing responses using AI.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutomotiveIntro;
